"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LoadingAnimationDefaultProps = exports.LoadingAnimation = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LoadingAnimation = function LoadingAnimation(props) {
  var classNames = props.classNames,
      strokeWidth = props.strokeWidth,
      strokeColor = props.strokeColor;
  var loadingAnimationClassNames = (0, _classnames.default)('loading-animation', classNames);
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: loadingAnimationClassNames,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0%",
    stopColor: "#018748"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "100%",
    stopColor: "#007FAD"
  }))), /*#__PURE__*/_react.default.createElement("circle", {
    className: "loading-animation__svg-circle",
    cx: "25",
    cy: "25",
    r: "20",
    strokeWidth: strokeWidth,
    stroke: strokeColor
  }));
};

exports.LoadingAnimation = LoadingAnimation;
LoadingAnimation.propTypes = {
  strokeWidth: _propTypes.default.string.isRequired,
  strokeColor: _propTypes.default.string.isRequired,
  classNames: _propTypes.default.any
};
var LoadingAnimationDefaultProps = {
  strokeWidth: '10%',
  strokeColor: 'url(#gradient)'
};
exports.LoadingAnimationDefaultProps = LoadingAnimationDefaultProps;
LoadingAnimation.defaultProps = LoadingAnimationDefaultProps;
var _default = LoadingAnimation;
exports.default = _default;